import * as runtime from '@/api/runtime'
import {
  BatchStatisticsPageLoadRequest,
  BatchStatisticsPageLoadRequestToJSON
} from '@/api'
import {
  BatchReminderLetterPageLoadResult,
  BatchReminderLetterPageLoadResultFromJSON
} from '@/api/models/batch/BatchReminderLetterPageLoadRequest'
import {
  BatchReminderLetterRequest,
  BatchReminderLetterRequestToJSON
} from '@/api/models/batch/BatchReminderLetterRequest'

export class BatchReminderLetterApi extends runtime.BaseAPI {
  /**
   * 画面初期表示時の検索状態取得
   * @param request
   */
  async readInitialPattern(
    request: BatchStatisticsPageLoadRequest
  ): Promise<BatchReminderLetterPageLoadResult> {
    const response = await this.requestGet(
      `/batch/statistics/search_initial_condition`,
      BatchStatisticsPageLoadRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BatchReminderLetterPageLoadResultFromJSON(jsonValue)
    ).value()
  }

  async createReminderList(
    request: BatchReminderLetterRequest
  ): Promise<number> {
    const response = await this.requestPost(
      `/batch/reminder/letter`,
      BatchReminderLetterRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }
}
